import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    fetching: false,
    error: {
        status: null,
        text: null,
    },
    data: [],
};

const gscReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.DATA_GSC_KEYWORDS_FETCHING: {
            return update(state, {
                fetching: { $set: true },
            });
        }
        case ActionTypes.DATA_GSC_KEYWORDS_RECEIVED: {
            return update(state, {
                fetching: { $set: false },
                data: { $set: action.payload },
                error: { $set: initialState.error },
            });
        }
        case ActionTypes.DATA_GSC_KEYWORDS_ERROR: {
            return update(state, {
                data: { $set: initialState.data },
                fetching: { $set: false },
                error: {
                    status: { $set: action.payload.status },
                    text: { $set: action.payload.text },
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default gscReducer;
